module.exports = __webpack_public_path__ + "img/trip.9ad4c87c.png";